import { Flex } from '@chakra-ui/react';
import { IPeerReviewListItem } from '@publishing-engine/domain/views';
import { DisplayField } from 'src/components/shared/DisplayField';

interface Props {
  review: IPeerReviewListItem;
  reviewFieldConfig: any;
  reviewerAnonymity: string | undefined;
  peerReviewTransparency: string | undefined;
}

const ReviewerOptIns: React.FC<Props> = ({
  review,
  reviewFieldConfig,
  peerReviewTransparency,
  reviewerAnonymity
}) => {
  const reviewAssessment =
    review.caseData.revisionAssessment ?? review.caseData.firstAssessment;

  return (
    reviewAssessment && (
      <Flex direction="column" gap={4}>
        <DisplayField
          fieldName="webOfScienceOptIn"
          value={
            'webOfScienceOptIn' in reviewAssessment &&
            reviewAssessment?.webOfScienceOptIn
              ? reviewAssessment?.webOfScienceOptIn
              : ''
          }
          config={reviewFieldConfig}
        />
        {!peerReviewTransparency && (
          <DisplayField
            fieldName="peerReviewTransparency"
            value={
              'peerReviewTransparency' in reviewAssessment &&
              reviewAssessment?.peerReviewTransparency
                ? reviewAssessment?.peerReviewTransparency
                : ''
            }
            config={reviewFieldConfig}
          />
        )}
        {!reviewerAnonymity && (
          <DisplayField
            fieldName="reviewerAnonymity"
            value={
              'reviewerAnonymity' in reviewAssessment &&
              reviewAssessment?.reviewerAnonymity
                ? reviewAssessment?.reviewerAnonymity
                : ''
            }
            config={reviewFieldConfig}
          />
        )}
        <DisplayField
          fieldName="receiveFeedback"
          value={
            'receiveFeedback' in reviewAssessment &&
            reviewAssessment?.receiveFeedback
              ? reviewAssessment?.receiveFeedback
              : ''
          }
          config={reviewFieldConfig}
        />
      </Flex>
    )
  );
};

export default ReviewerOptIns;
